import { useHeroImageModalStore } from "../../../js/stores/hero-image-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { HeroImageModal } from "./hero-image-modal";

export const HeroImageWidget = ({ heroUrl }) => {
  const isModalOpen = useHeroImageModalStore((state) => state.isModalOpen);
  const openModal = useHeroImageModalStore((state) => state.openModal);
  const closeModal = useHeroImageModalStore((state) => state.closeModal);
  const updateIsModalOpen = useHeroImageModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <div className="hero-image__wrapper">
      <div
        className="hero-image__preview"
        style={{ backgroundImage: heroUrl ? `url(${heroUrl})` : "none" }}
      >
        {!heroUrl && <span className="hero-image__placeholder">No cover image</span>}
      </div>

      <button className="hero-image__popup-button" onClick={openModal}>Upload cover image</button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => updateIsModalOpen(false)}
          onOpenChange={updateIsModalOpen}
        >
          <DialogContent>
            <HeroImageModal closeModal={closeModal} />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};
